module.exports = __webpack_public_path__ + "4104433b2fb2a40eb7cda4e76ee72525.svg";